import Vue from "vue"

let current: Vue | undefined = undefined
let currentIsPersistent = false

export default {
    set(dialog: Vue, value: boolean, persistent = false) {
        if (value) {
            current = dialog
            currentIsPersistent = persistent
        } else if (current == dialog) {
            current = undefined
            currentIsPersistent = false
        }
    },
    get() {
        return current
    },
    preventNavigation() {
        if (current && !currentIsPersistent && (current as any).show) {
            (current as any).show = false
            return true
        } else if (current && currentIsPersistent) {
            return true
        }
        return false
    }
}
